import { useQuery } from "@tanstack/react-query";
import { fetchNoteDetail } from "../services/notesService";

export async function loadNoteDetail(params) {
  const { payload, meta } = await fetchNoteDetail(params);
  if (meta?.error || (meta?.code != null && Number(meta.code) !== 200)) throw new Error(meta.message || 'Unable to load note.');
  const note = payload?.notes_data || {};

  return {
    raw: payload,
    stateName: payload?.state_name || "",
    subjectName: payload?.subject_name || "",
    categoryName: payload?.category_name || "Notes",
    topicName: payload?.topic_name || "",
    totalNotesCount: Number(payload?.total_notes_count || 0),
    viewCountSeconds: Number(payload?.view_count_seconds || 0),
    note: {
      raw: { ...payload, ...note, ...(params.ad_reward_id ? { ad_reward_id: params.ad_reward_id } : {}) },
      id: Number(note?.note_id || 0),
      index: Number(note?.note_index || 0),
      previousId: Number(note?.previous_note_id || 0),
      nextId: Number(note?.next_note_id || 0),
      previousFreePaid: String(note?.previous_note_free_paid || "F").toUpperCase(),
      nextFreePaid: String(note?.next_note_free_paid || "F").toUpperCase(),
      timerSeconds: Number(note?.timer_seconds || 0),
      title: note?.name || "Note",
      description: note?.description || "",
      summary: note?.summary || "",
      isBookmarked: Number(note?.bookmark_status || 0) === 1,
      isLiked: Number(note?.like_status || 0) === 1,
      likeCount: Number(note?.total_likes || 0),
      viewCount: Number(note?.total_views || 0),
      reportCount: note?.total_reports || "0",
      personalNotesCount: Number(note?.total_notes || 0),
      isRead: Number(note?.view_status || note?.is_notes_read || note?.read_status || 0) === 1,
      type: String(note?.notes_type || "T").toUpperCase(),
      fileDisplay: note?.file_display || "",
      fileUrl: note?.file_url || "",
      freePaid: String(note?.free_paid || "F").toUpperCase(),
      paymentStatus: Number(note?.payment_status || 0),
      isDownloadable: Number(note?.is_downloadable || 0) === 1,
    },
  };
}

export function useNoteDetail(params = {}, options = {}) {
  return useQuery({
    queryKey: ["noteDetail", params],
    queryFn: () => loadNoteDetail(params),
    enabled: options.enabled ?? true,
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
  });
}
